import React from 'react';
import { PropTypes } from 'prop-types';
import Description from './Description';
import Title from './Title';

const NonField = ({ field }) => {
    switch (field?.presentation?.displayType) {
        case 0:
            return <Title field={field} />;
        case 1:
            return <Description field={field} />;
        default:
            return null;
    }
};
NonField.propTypes = {
    field: PropTypes.object
};
export default NonField;
